import { useUserEventLogger } from '@repo/tracking-service';
import { useAuthContext } from '@repo/user-session';
import { Button, Guide, Title } from '@zenterprise-inc/ui';

import Illust2Logos from '@/assets/illust-icons/illust-2logos.svg';

const DecisionSimpleAuthSection = ({ handleSimpleAuthStep }: { handleSimpleAuthStep: () => void }) => {
  const { auth } = useAuthContext();
  const { sendClickEvent } = useUserEventLogger();

  const handleClick = () => {
    sendClickEvent('indis-decision_selectauth_simplecert');

    handleSimpleAuthStep();
  };

  const userName = auth.user?.name || '고객';
  const titleText = (
    <>
      <span className={'break-all'}>{userName}</span>님, 어떤 방법으로
      <br />
      환급 결과를 확인할까요?
    </>
  );

  return (
    <div className="page-padding flex w-full flex-col">
      <Title.Headline title={titleText} size="large" />
      <div className="pb-8" />
      <Guide>
        <Guide.ImageArea>
          <Illust2Logos />
        </Guide.ImageArea>
        <Guide.TextArea>
          <Guide.Title titleType="large" className="text-gray-900">
            간편인증으로 확인하기
          </Guide.Title>
          <Guide.Description className="body-16">카카오톡, 네이버로 가능해요.</Guide.Description>
        </Guide.TextArea>
        <Guide.ButtonArea>
          <Button.Box size="large" state="primary" onClick={handleClick}>
            바로 확인하기
          </Button.Box>
        </Guide.ButtonArea>
      </Guide>
    </div>
  );
};

export default DecisionSimpleAuthSection;
